import {
  ExtractDocumentTypeFromTypedRxJsonSchema,
  RxCollection,
  RxDocument,
  RxJsonSchema,
  toTypedRxJsonSchema,
} from 'rxdb'

export const signatureSchemaLiteral = {
  title: 'Signature Schema',
  description: 'Describes a signature, used to sign pack messages',
  version: 0,
  keyCompression: false,
  primaryKey: 'id',
  type: 'object',
  properties: {
    id: {
      type: 'string',
      maxLength: 100,
    },
    user: {
      ref: 'users',
      type: 'string',
    },
    name: {
      type: 'string',
    },
    title: {
      type: ['string', 'null'],
    },
    telephone: {
      type: ['string', 'null'],
    },
    email: {
      type: ['string', 'null'],
    },
    image: {
      type: ['string', 'null'],
    },
    linkedin: {
      type: ['string', 'null'],
    },
    bio: {
      type: ['string', 'null'],
    },
    specialisms: {
      type: ['string', 'null'],
    },
  },
  required: ['id', 'user', 'name'],
  indexes: [],
} as const

const schemaTyped = toTypedRxJsonSchema(signatureSchemaLiteral)

export type SignatureDocType = ExtractDocumentTypeFromTypedRxJsonSchema<typeof schemaTyped>

export const signatureSchema: RxJsonSchema<SignatureDocType> = schemaTyped

export type SignatureDocMethods = {
  test: () => void
}

export type SignatureDocument = RxDocument<SignatureDocType, SignatureDocMethods>

export type SignatureCollectionMethods = {
  test: () => void
}

export type SignatureCollection = RxCollection<SignatureDocType, SignatureDocMethods, SignatureCollectionMethods>
